export const customColors = {
  blue: {
    main: '#1181E9',
    dark: '#1976D2',
  },
  green: {
    main: '#1AC156',
    dark: '#388E3C',
  },
  yellow: {
    main: '#F5C411',
    dark: '#FFD600',
  },
  red: {
    main: '#FF3C3C',
    dark: '#D32F2F',
  },
  neutral: {
    background: '#EFEFEF',
    outline: '#BCBDBD',
    darkBackground: '#23272F',
    darkOutline: '#44474F',
  },
  amber: {
    main: '#FFAB00',
    dark: '#FFB300',
  },
  cyan: {
    main: '#00ACC1',
    dark: '#00838F',
  },
  orange: {
    main: '#F57C00',
    dark: '#FF9800',
  },
  purple: {
    main: '#6A1B9A',
    dark: '#8E24AA',
  },
  velvet: {
    main: '#6270A0',
  },
  cloud: {
    main: '#E8E9F1',
  },
  brown: {
    light: '#EFEBE9',
    main: '#795548',
    dark: '#3E2723',
  },
  teal: {
    main: '#009688',
  },
  warning: {
    main: '#FB8C00',
    light: '#FFF4E5',
    dark: '#3E2D12',
  },
  background: {
    dark: '#1F252C',
    darker: '#181C20',
  },
  ag: {
    input: {
      borderColor: '#BABFC7',
      disabledBorderColor: 'rgba(186, 191, 199, 0.30)',
      disabledBackgroundColor: 'rgba(186, 191, 199, 0.15)',
      darkBorderColor: '#44474F',
      darkDisabledBorderColor: 'rgba(68, 71, 79, 0.30)',
      darkDisabledBackgroundColor: 'rgba(68, 71, 79, 0.15)',
    },
    header: {
      backgroundColor: '#F8F8F8',
      darkBackgroundColor: '#252A30',
    },
  },
};

export const LEFT_MENU_WIDTH = 120;
export const HEADER_HEIGHT = 64;

export const TAB_FULL_WIDTH = `calc(100vw - ${LEFT_MENU_WIDTH}px - 2 * 24px)`;
export const TAB_FULL_SCREEN_WIDTH = 'calc(100vw - 2 * 24px)';
